import React from 'react'
import * as styles from './styles'

export default function CrewImages() {
  return (
    <styles.Container>
      <styles.ImageGroup>
        <styles.ImageContainer>
          <styles.CrewImage src="https://s3.eu-central-1.amazonaws.com/aitoai-public/website-assets/people/vesku-pink.jpg" />
        </styles.ImageContainer>
        <styles.ImageContainer>
          <styles.CrewImage src="https://s3.eu-central-1.amazonaws.com/aitoai-public/website-assets/people/antti-pink.jpg" />
        </styles.ImageContainer>
        <styles.ImageContainer>
          <styles.CrewImage src="https://s3.eu-central-1.amazonaws.com/aitoai-public/website-assets/people/kai-pink.jpg" />
        </styles.ImageContainer>
      </styles.ImageGroup>
    </styles.Container>
  )
}
